/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class InstallationEvents extends Model {
  @attr() report;
}
